import Axios, { AxiosInstance } from 'axios';
import { Application } from '../rest/application';

/**
 *
 * @author Wang Jianchao(tinyking)
 * @version 1.0
 * @since 2020/8/19
 */
export class RestHelper {
  private static HTTP_CLIENT: AxiosInstance = Axios.create();
  private static DEFAULT_APPLICATION: Application = new Application('api');

  static set client(http) {
    RestHelper.HTTP_CLIENT = http;
  }

  static get client() {
    return RestHelper.HTTP_CLIENT;
  }

  static setDefaultApplication(application: Application) {
    return (RestHelper.DEFAULT_APPLICATION = application);
  }

  static getDefaultApplication() {
    return RestHelper.DEFAULT_APPLICATION;
  }
}
